import React from 'react';
import { useSiteContent } from '../../useSiteContent';
import './Story.css';

const Story = () => {
    const { getContent } = useSiteContent();

    return (
        <section className="story-section" id="story">
            <div className="story-container">
                <div className="story-grid">
                    <div className="story-image">
                        <img src="/assets/Img44.webp" alt="The Story of GAWAH" />
                    </div>
                    <div className="story-content">
                        <h2 className="story-title">{getContent('story_title', 'A legacy that refused to stay buried')}</h2>
                        <p>{getContent('story_p1', 'Sadhu Sundar Singh disappeared into the Himalayas in 1929, and with him, the world assumed, went the last chapter of his story. But history often forgets the sequel.')}</p>
                        <p>{getContent('story_p2', 'His nephew Sadhu Kishan Singh and his niece Shanta Kaur chose to leave comfort behind and follow the same Christ their uncle had given everything for. Their journey carried them into danger, opposition, sickness and moments that had no earthly explanation. Entire villages encountered the Gospel because two people decided obedience was worth the cost. Many found faith. Some paid dearly for it.')}</p>
                        <p>{getContent('story_p3', 'GAWAH – The Witness is the film that brings their true story to the screen, based on the book Thunder in the Himalayas by Dr. Babu K. Verghese.')}</p>
                    </div>
                </div>
                <div className="story-footer-caption">
                    <p className="story-caption-intro">{getContent('story_caption_intro', 'And it leaves you with the same question it asks everyone who watches:')}</p>
                    <p className="story-caption-question">{getContent('story_caption_question', 'What does wholehearted devotion to Christ actually look like?')}</p>
                </div>
            </div>
        </section>
    );
};

export default Story;

